<template lang="pug">
//- app-page(:fabItems="fabItems" title="Материалы для распределения" :loading="loadingNew"  @search="text => (search = text.toLowerCase())")
app-page(:fabItems="fabItems" title="Материалы для распределения" @search="text => (search = text.toLowerCase())")
  app-toolbar(:title="'Реестр поступивших материалов/дел'")
    app-toolbar-item-period-short.ml-6(@select="setPeriod") {{ period ? period.text : 'все' }} 
    //- app-toolbar-item-period.ml-6(@select="setPeriod") {{ period ? period.text : 'все' }} 
    app-toolbar-item.ml-2(v-if="listCaseTypes.length > 1" label="Тип" all="все" :items="listCaseTypes" key-name="title" min-width="120" @select="selectCaseType" maxHeight="500px") 
      | {{ selectedCaseType ? selectedCaseType.title : 'все'}}

  .text-right
    v-chip.ma-2(v-if="search" color="#757575" text-color="white" small label close @click:close="search = null") Поиск:&nbsp;<b>{{ search }}</b>
    v-chip.ma-2(v-if="selectedCaseType" color="#757575" text-color="white" small label close @click:close="selectCaseType(null)") Тип дел: <b>{{ selectedCaseType.title  }}</b>
    v-chip.ma-2(v-if="period" color="#757575" text-color="white" small label close @click:close="setPeriod(null)") Период: <b>{{ period.text  }}</b>

  app-empty-list(v-if="newCase.length == 0") Список пуст
  app-group-animation
    app-group-item(v-for="c in newCase" :key="c.id" cols="4" data-aos="fade-top")
      caseDistribItem(:caseItem="c" :search="search" @click.native="showDeleteCase(c)")

  app-dialog-confirm(v-model="dialog.deleteCase" @confirm="deleteCase()")
    app-card-title.mt-5 Удалить дело №{{currentCourtCase.number}} из распределения?

  app-dialog(v-model="dialog.confirmDistrib" header="Распределение закончено") Ни кто из судей не рассматривает дела данных категорий

  app-dialog(v-model="dialog.sync" ref="caseSyncPeriod" header="Выбрать период" confirm-text="Загрузить" @confirm="syncNewCasePeriod()")
    app-date-picker(v-model="syncStartPeriod" viewFormat="DD.MM.YYYY" format="YYYY-MM-DD")
    app-date-picker(v-model="syncEndPeriod" viewFormat="DD.MM.YYYY" format="YYYY-MM-DD")

  app-dialog-loading(v-model="loading")

  v-btn.done-btn(@click.native="distributionCase()" color="#1B93AD" fixed right bottom) Распределить (всего дел: {{ newCase.length }})
</template>

<script>
import { distribService, syncService, userService, caseService } from "@/_services";
import { $_app_moment } from "@/common/AppMoment.js"
import { AppDialogConfirm, AppDialogLoading } from '@/components'
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex'
import caseDistribItem  from './components/caseDistribItem' 
import refreshable from '@/common/Refreshable'

import moment from 'moment'
moment.locale('ru')

let typeSync = {
  TODAY: 0,
  PERIOD: 1,
}
let typeCase = {
  CIVIL: 0,
  ADMINISTRATIVE: 1,
  CRIMINAL: 2,
}

export default {
  mixins: [ $_app_moment, refreshable ],

  components: {
    [AppDialogConfirm.name]: AppDialogConfirm,
    [AppDialogLoading.name]: AppDialogLoading,
    caseDistribItem
  },
  
  data () {
    return {
      search: null, 
      syncStartPeriod: moment().format('YYYY-MM-DD'),
      syncEndPeriod: moment().format('YYYY-MM-DD'),
      dialog: {
        sync: false,
        confirmDistrib: false,
        deleteCase: false
      },
      currentCourtCase: {},
      loading: false,
    }
  },

  mounted () {
    this.$store.commit('setInJudgeReestr', true)
    this.$store.dispatch('judgeReestr/LOAD_CASE_TYPES')

    this.$store.commit('setInDistribution', true)
    this.$store.dispatch('distribution/LOAD_NEW')

    this.$store.dispatch('list/GET_STATUSES')
    
  },

  computed: {
    ...mapGetters('judgeReestr', ['caseTypes']),
    ...mapState('distribution', ['period', 'selectedCaseType']),
    ...mapGetters('distribution', ['distribNew', 'isDistribNew']),
    ...mapGetters('list', ['statuses']),

    // loadingNew () {
    //   return !this.isDistribNew
    //   return false
    // },

    listCaseTypes() {
      if (userService.existRole('CHAIRMAN') ) return [...this.caseTypes, {value: -1, title: "Гражданские без 13-", name: "CIVIL_NOT_13"}]
      let list = []
      this.caseTypes.filter(item => {
        if (userService.existRole('DISTRIBUTION_G') && item.name.indexOf("CIVIL") != -1) {
          list = [...list, item, {value: -1, title: "Гражданские без 13-", name: "CIVIL_NOT_13"}]
        }
        if (userService.existRole('DISTRIBUTION_A') && item.name.indexOf("ADMINISTRATIVE") != -1) list = [...list, item]
        if (userService.existRole('DISTRIBUTION_U') && item.name.indexOf("CRIMINAL") != -1) list = [...list, item]
      })
      return list
    },

    fabItems () {
      return [
        { icon:'sync', title:'Синхронизация дел/материалов', action: () =>  this.syncNewCase(typeSync.TODAY) },
        { icon:'sync', title:'Синхронизация дел/материалов за период', action: () =>  this.$refs.caseSyncPeriod.show() }
      ]
    },

    newCase () {
      return this.getList()
    },
  },

  methods: {
    ...mapMutations('distribution', ['setDistribNew', 'setPeriod', 'selectCaseType']),
    ...mapActions('distribution', ['refresh']),

    $_refresh () {
      this.refresh().then(() => {})
    },

    getList () {
      let list = []

      if (userService.existRole('DISTRIBUTION_G') ) {
        list = [...list, ...this.distribNew.filter(c => c.caseType.value == typeCase.CIVIL)]
      }
      if (userService.existRole('DISTRIBUTION_A') ) {
        list = [...list, ...this.distribNew.filter(c => c.caseType.value == typeCase.ADMINISTRATIVE || c.number.startsWith("2а-") || c.number.startsWith("9а-") || c.number.startsWith("11а-") || c.number.startsWith("13а-"))]
      }
      if (userService.existRole('DISTRIBUTION_U') ) {
        list = [...list, ...this.distribNew.filter(c => c.caseType.value == typeCase.CRIMINAL)]
      }

      if (userService.existRole('CHAIRMAN') ) list = this.distribNew

      if (this.selectedCaseType) {
        if (this.selectedCaseType.value == -1)
          list = list.filter(c => c.number.indexOf("13-") == -1 && c.caseType.value == 0)
        else 
          list = list.filter(c => c.caseType.value == this.selectedCaseType.value)
      }

      if (this.search) {
        list = [
          ...list.filter(item => item.number.toLowerCase().includes(this.search)),
          ...list.filter(item => item.caseCategory && item.caseCategory.title.toLowerCase().includes(this.search)),
          ...list.filter(item => item.mainLawArticle && item.mainLawArticle.toLowerCase().includes(this.search))
        ]
      }

      if (this.period) {
        list = list.filter(item => {
          let date = moment(new Date(item.createDate)).format("YYYY-MM-DD")
          if (moment(date).isBetween(this.period.start, this.period.end, 'day', '[]')) return item
        })
      }

      return list
    },

    syncNewCasePeriod() {
      this.syncNewCase(typeSync.PERIOD)
    },

    syncNewCase (type) {
      this.loading = true
      let query = typeSync.TODAY == type ? syncService.syncNewCase() : syncService.syncNewCaseByPeriod(this.syncStartPeriod, this.syncEndPeriod)
      query.then(() => {
        this.loading = false
        this.$store.dispatch('distribution/LOAD_NEW')
      })
      .catch(() => this.loading = false )
    },

    distributionCase () {
      this.loading = true
      let caseIds = this.getList().map(item => item.id)
      let obj = { "caseIds": "" + caseIds.join(",") }
      distribService.distributionCase(obj).then(data => {
        // let list = data.filter(newCase => !newCase.judge)
        if (data.length > 0) {
          let list = this.getList().filter(newCase => !data.find(item => item.judge && item.id == newCase.id))
          this.setDistribNew(list)
        }
        this.loading = false
      })
    },

    showDeleteCase (courtCase) {
      this.currentCourtCase = courtCase
      this.dialog.deleteCase = true
    },

    deleteCase () {
        this.loading = true
        this.currentCourtCase.caseStatus = this.statuses.find(item => item.name == 'Delete')
        caseService.add(this.currentCourtCase).then(() => {
          let list = this.newCase.filter(item => item.id != this.currentCourtCase.id)
          this.setDistribNew(list)
          this.loading = false
        })

        
    },
  },
  beforeDestroy() {
    this.$store.commit('setInJudgeReestr', false),
    this.$store.commit('setInDistribution', false)
  }
}
</script>

<style scoped>
  .done-btn {
    right: 40%;
    bottom: 25px;
  }
</style>